/**
 * Оставляет в строке только цифры телефона.
 * @param phone — исходный номер с маской/спецсимволами
 * @returns строка только из цифр
 */
export const extractPhoneDigits = (
  phone?: string | null,
): string => {
  return phone?.replace(/\D/g, '') ?? '';
};

/**
 * Нормализует email: trim + нижний регистр.
 * @param email — исходный email
 * @returns нормализованный email или пустая строка
 */
export const normalizeEmail = (email?: string | null): string => {
  return email?.trim?.()?.toLowerCase?.() ?? '';
};
